import { MapPin, Navigation } from "lucide-react";

const Location = () => {
  const handleDirections = () => {
    window.open(
      "https://www.google.com/maps/dir/?api=1&destination=C.+Médicos+Mundi,+2,+41020+Sevilla",
      "_blank"
    );
  };

  return (
    <section id="contacto" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            Encuéntranos
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Ven a Visitarnos
          </h2>
          <p className="font-body text-[#1A1A1A]/70 max-w-2xl mx-auto">
            Nos encontrarás en el Mercado de Abastos de Sevilla Este, un lugar ideal
            para disfrutar de tapas, vinos y buen ambiente.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="map-container h-[400px] lg:h-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.0!2d-5.92!3d37.38!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDIyJzQ4LjAiTiA1wrA1NSc0OC4wIlc!5e0!3m2!1ses!2ses!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Abacería Como en Casa"
            />
          </div>

          {/* Info */}
          <div className="flex flex-col justify-center">
            <div className="bg-[#F9F7F2] p-8 border border-[#DCD7CC]">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#800020] text-white flex-shrink-0">
                  <MapPin size={20} />
                </div>
                <div>
                  <h3 className="font-heading text-xl text-[#1A1A1A] mb-2">
                    Dirección
                  </h3>
                  <p className="font-body text-[#1A1A1A]/80">
                    C. Médicos Mundi, 2
                    <br />
                    41020 Sevilla
                  </p>
                  <p className="font-accent text-[#800020] mt-2">
                    Mercado de Abastos Sevilla Este
                  </p>
                </div>
              </div>

              <p className="font-body text-[#1A1A1A]/70 mb-6">
                Perfecto para una cena entre amigos, una copa de vino o empezar la
                noche con buen ambiente.
              </p>

              <button
                onClick={handleDirections}
                data-testid="directions-btn"
                className="btn-primary w-full flex items-center justify-center gap-2"
              >
                <Navigation size={16} />
                Cómo Llegar
              </button>
            </div>

            {/* Additional info */}
            <div className="mt-6 p-6 border border-[#DCD7CC]">
              <h4 className="font-heading text-lg text-[#1A1A1A] mb-3">
                Aparcamiento
              </h4>
              <p className="font-body text-[#1A1A1A]/70 text-sm">
                Disponemos de parking gratuito en las inmediaciones del Mercado de
                Abastos de Sevilla Este.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
